export enum ErrorMsgType {
    NO_ERROR = 0,
    FETCH_ERROR = 1,
    SAVE_ERROR = 2
  }